export default function JobStarOnlyIco({ fill = "#0070F2", size }) {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99271 0.528784C5.36921 -0.176946 6.38079 -0.176947 6.75729 0.528784L8.16709 3.17132C8.26043 3.3463 8.4037 3.48957 8.57868 3.58291L11.2212 4.99271C11.9269 5.36921 11.9269 6.38079 11.2212 6.75729L8.57868 8.16709C8.4037 8.26043 8.26043 8.4037 8.16709 8.57868L6.75729 11.2212C6.38079 11.9269 5.36921 11.9269 4.99271 11.2212L3.58291 8.57868C3.48957 8.4037 3.3463 8.26043 3.17132 8.16709L0.528784 6.75729C-0.176946 6.38079 -0.176947 5.36921 0.528784 4.99271L3.17132 3.58291C3.3463 3.48957 3.48957 3.3463 3.58291 3.17132L4.99271 0.528784Z"
        fill={fill}
      />
    </svg>
  );
}
